

export const contactForm = {
	id: 'discover',
	lightBg: true,
	lightText: false,
	lightTextDesc: false,
	topLine: 'Company',
	headline: 'Sneaky Travels',
	description: '',
	buttonLabel: "Contact for more details",
	imgStart: false,
	img: require(`../../images/company-logo.png`).default,
	alt: 'Planet',
	dark: false,
	primary: false,
	darkText: true,
}